var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemocraticRepublicOfTheCongo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1305)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 0H0V40H53V0Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.385 8H7.95L9.6725 2.4L11.395 8H16.96L12.455 11.4667L14.1775 17.0667L9.6725 13.6L5.1675 17.0667L6.89 11.4667L2.385 8ZM49.6875 0L0 30V40H3.3125L53 10V0H49.6875Z",
    fill: "#F7D618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 0L0 32V40L53 8V0Z",
    fill: "#CE1021"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_1305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemocraticRepublicOfTheCongo);
export default __webpack_public_path__ + "static/media/democratic_republic_of_the_congo.f0ac76b83de8514ffcf581287d7a85a8.svg";
export { ForwardRef as ReactComponent };